<main class="mx-auto flex w-full max-w-7xl flex-auto flex-col justify-center px-6 py-24 sm:py-32 lg:px-8" role="alert" aria-labelledby="error-title">
    <p class="text-base/8 font-semibold text-blue-600">404</p>
    <h1 id="error-title" class="mt-4 text-pretty text-3xl font-header tracking-tight text-gray-900 sm:text-4xl">
        Oeps, deze pagina bestaat niet
    </h1>
    <p class="mt-6 text-pretty text-lg font-normal text-gray-500 sm:text-xl/8">
        Het lijkt erop dat je een pagina probeert te bereiken die niet (meer) bestaat of is verplaatst.<br>
        Geen zorgen - we helpen je graag weer op weg.
    </p>
    <ul role="list" class="mt-8 divide-y divide-gray-900/5 border-b border-gray-900/5">
        @for (link of resourceLinks; track link.path) {
            <li class="relative flex gap-x-6 py-6 group">
                <div class="flex-auto">
                    <h3 class="text-md font-semibold text-gray-900 group-hover:underline">
                        <a [routerLink]="[link.path]">
                            <span class="absolute inset-0" aria-hidden="true"></span>
                            {{ link.title }}
                        </a>
                    </h3>
                    <p class="mt-2 text-md/2 text-gray-600">{{ link.description }}</p>
                </div>
                <div class="flex-none self-center">
                    <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                    </svg>
                </div>
            </li>
        }
    </ul>
    <p class="mt-16 text-pretty text-base text-gray-500">
        Als je denkt dat dit een fout is of hulp nodig hebt, neem dan <a [routerLink]="['/contact']" class="text-blue-600 hover:text-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">contact met ons op</a>.
    </p>
    <div class="mt-8">
        <a [routerLink]="['/']" class="inline-flex items-center gap-2 rounded-md pr-4 py-2 text-lg font-medium text-blue-600 hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors">
            <span aria-hidden="true">←</span>
            Terug naar startpagina
        </a>
    </div>
</main>
